// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3IsoQ","consentsList":"PatientConsents_consentsList__17uNL","consentsListEmpty":"PatientConsents_consentsListEmpty__2OOHT"};